import React, {PropsWithChildren, useEffect} from 'react'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {DrawerMessenger, ActivityDrawer, Main, InviteUsers, UpgradePlan} from '../partials'
import {MenuComponent} from '../assets/ts/components'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../setup'
import * as auth from '../../app/modules/auth/redux/AuthRedux'
import SessionExpiredModal from '../../app/shared/components/SessionExpiredModal'
import {ReportGenerationToastProvider} from '../../app/shared/context/ReportGenerationToastContext'
import {ReportGenerationJobTrackerProvider} from '../../app/shared/context/ReportGenerationJobTrackerContext'
import {PcgReportGenerationTrackerProvider} from '../../app/modules/pcgreport/context/PcgReportGenerationTrackerContext'

const MasterLayout: React.FC<PropsWithChildren<{}>> = ({children}) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const sessionExpired = useSelector<RootState, boolean>(({auth}) => auth.sessionExpired ?? false)

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  const handleLoginAgain = () => {
    dispatch(auth.actions.logout())
  }

  return (
    <PageDataProvider>
      <ReportGenerationToastProvider>
        <ReportGenerationJobTrackerProvider>
          <PcgReportGenerationTrackerProvider>
            <div className='page d-flex flex-row flex-column-fluid'>
              <AsideDefault />
              <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
                <HeaderWrapper />

                <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                  <div className='post d-flex flex-column-fluid' id='kt_post'>
                    <Content>{children}</Content>
                  </div>
                </div>
                <Footer />
              </div>
            </div>
            {/* begin:: Drawers */}
            <ActivityDrawer />
            <DrawerMessenger />
            {/* end:: Drawers */}

            {/* begin:: Modals */}
            <Main />
            <InviteUsers />
            <UpgradePlan />
            <SessionExpiredModal show={sessionExpired} onLoginAgain={handleLoginAgain} />
            {/* end:: Modals */}
            <ScrollTop />
          </PcgReportGenerationTrackerProvider>
        </ReportGenerationJobTrackerProvider>
      </ReportGenerationToastProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
